import PrintProductIndividual from './PrintProductIndividual';

export default PrintProductIndividual;
